import React from "react";
import "./custom-pagination.css";
import ReactPaginate from "react-paginate";
import { CustomPaginationProps } from "../../utils/constants/Interfaces.constants";

const CustomPagination: React.FunctionComponent<CustomPaginationProps> = ({ handlePageClick, pageCount, pageNumber=0 }) => {

  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel=">"
      onPageChange={(ev) => handlePageClick(ev)}
      pageRangeDisplayed={window.screen.width <= 768 ? 1 : 2}
      pageCount={pageCount}
      previousLabel="<"
      renderOnZeroPageCount={null}
      marginPagesDisplayed={1}
      disabledClassName="mf-custom-pagination-disabled"
      className="mf-custom-pagination no-list-style d-flex align-itesm-center justify-content-center"
      forcePage={pageNumber + 1}
    />
  );
};

export default CustomPagination;
